















import { Component, Vue } from 'vue-property-decorator';

import EditLayout from '../EditLayout.vue';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';

import ConsultationsModule from '@/store/patients/consultations';

import { editTabsNav } from "@/store/patients/tabs";

@Component({
    components: {
        EditLayout,
        Layout,
        ListBlock,
    }
})
export default class PatientsEditConsultationsPage extends Vue {
    repository = ConsultationsModule;

    get tabsNav() {
        return editTabsNav;
    }

    get currentTab() {
        const tabs = Object.values(this.tabsNav);
        const currentTab = tabs.find(tab => tab.pathName === this.$route.name);

        return currentTab?.id ?? '';
    }

    get patientId() {
        return this.$route.params.patientsId;
    }

    get filterSettings() {
        return ConsultationsModule.filter.filterSettings;
    }
    
    toAdd() {
        this.$router.push({ name: 'clinics_create' });
    }

    async updateList() {
        await ConsultationsModule.filter.updateFilter();
        await ConsultationsModule.getList();
    }

    async resetFilters() {
        await ConsultationsModule.clearSort();
        await ConsultationsModule.filter.resetFilter();
        await ConsultationsModule.getList();
    }

    async created() {
        await ConsultationsModule.setPatientId(this.patientId);
    }

    beforeDestroy() {
        ConsultationsModule.clearList()
    }
}
